// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'

export const getData = createAsyncThunk('appDashboardsCoc/getData', async ({ setBlock, ...params }) => {

  setBlock(true)

  const response = await axios.get('/apps/dashboardscoc/list', params)

  setBlock(false)

  return {
    params,
    data:       response.data.dashboardscoc,
    allData:    response.data.allData,
    totalPages: response.data.total
  }
})

export const appDashboardsCocSlice = createSlice({
  name: 'appDashboardsCoc',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: []
  },
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getData.fulfilled, (state, action) => {
      state.data    = action.payload.data
      state.allData = action.payload.allData
      state.total   = action.payload.totalPages
      state.params  = action.payload.params
    })
  }
})

export default appDashboardsCocSlice.reducer
